import { createContext, useContext } from 'react';

const EmptyStateContext = /*#__PURE__*/createContext({});
const EmptyStateProvider = EmptyStateContext.Provider;
const useEmptyStateContext = () => {
  return useContext(EmptyStateContext);
};

export { EmptyStateProvider, useEmptyStateContext };
